// Maps Kivo Calendar API availableMeetingTypes to UI platform ids and booking meetingType.

import googleMeetLogo from 'dashboard/assets/images/meeting-platforms/google-meet.svg';
import microsoftTeamsLogo from 'dashboard/assets/images/meeting-platforms/microsoft-teams.svg';
import zoomLogo from 'dashboard/assets/images/meeting-platforms/zoom.svg';
import otherLogo from 'dashboard/assets/images/meeting-platforms/other.svg';

export const KIVO_MEETING_PLATFORM_CONFIG = {
  GOOGLE_CALENDAR: {
    id: 'google_meet',
    meetingType: 'GOOGLE_CALENDAR',
    labelKey: 'SCHEDULE_DEMO.PLATFORM_GOOGLE_MEET',
    logo: googleMeetLogo,
  },
  MICROSOFT_CALENDAR: {
    id: 'microsoft_teams',
    meetingType: 'MICROSOFT_CALENDAR',
    labelKey: 'SCHEDULE_DEMO.PLATFORM_MICROSOFT_TEAMS',
    logo: microsoftTeamsLogo,
  },
  ZOOM: {
    id: 'zoom',
    meetingType: null,
    labelKey: 'SCHEDULE_DEMO.PLATFORM_ZOOM',
    logo: zoomLogo,
  },
  OTHER: {
    id: 'other',
    meetingType: null,
    labelKey: 'SCHEDULE_DEMO.PLATFORM_OTHER',
    logo: otherLogo,
  },
};

export const DEFAULT_KIVO_MEETING_TYPES = ['GOOGLE_CALENDAR', 'MICROSOFT_CALENDAR'];
export const EXTERNAL_MEETING_TYPES = [
  'GOOGLE_CALENDAR',
  'MICROSOFT_CALENDAR',
  'ZOOM',
  'OTHER',
];

export const buildMeetingPlatformOptions = (availableTypes, t) => {
  const types = Array.isArray(availableTypes) ? availableTypes : [];
  return types
    .map(type => KIVO_MEETING_PLATFORM_CONFIG[type])
    .filter(Boolean)
    .map(config => ({
      id: config.id,
      meetingType: config.meetingType,
      label: t(config.labelKey),
      logo: config.logo,
    }));
};

export const meetingTypeForPlatformId = platformId => {
  const entry = Object.values(KIVO_MEETING_PLATFORM_CONFIG).find(
    config => config.id === platformId
  );
  return entry?.meetingType || 'GOOGLE_CALENDAR';
};
